import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Dashboard as DashboardIcon,
  AccessTime as AttendanceIcon,
  ShoppingCart as StockInIcon,
  ShoppingCartCheckout as StockOutIcon,
  LocalShipping as TransportIcon,
  Assessment as ReportsIcon,
  Business as VendorsIcon,
  PhotoLibrary as GalleryIcon,
  Person as UserIcon,
  Build as MaintenanceIcon,
  AttachMoney as AdvanceDetailsIcon
} from '@mui/icons-material';

const SideNav = ({ isOpen, onClose, isCollapsed }) => {
  const location = useLocation();

  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: DashboardIcon },
    { name: 'Attendance', href: '/attendance', icon: AttendanceIcon },
    { name: 'Users', href: '/userDetails', icon: UserIcon },
    { name: 'Stock In', href: '/stock-in', icon: StockInIcon },
    { name: 'Stock Out', href: '/stock-out', icon: StockOutIcon },
    { name: 'Transport', href: '/transport', icon: TransportIcon },
    // { name: 'Reports', href: '/reports', icon: ReportsIcon },
    // { name: 'Reports', href: '/reports1', icon: ReportsIcon },
    { name: 'Vendors', href: '/vendors', icon: VendorsIcon },
    { name: 'Advance Details', href: '/advance-details', icon: AdvanceDetailsIcon },
    { name: 'Gallery', href: '/gallery', icon: GalleryIcon },
    { name: 'Maintenance', href: '/maintenance', icon: MaintenanceIcon },
  ];

  const isActive = (href) => {
    if (href === '/dashboard') {
      return location.pathname === '/dashboard';
    }
    return location.pathname.startsWith(href);
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-40 bg-gray-600 bg-opacity-75 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-50 bg-white shadow-lg transform transition-all duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0 lg:h-full
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        ${isCollapsed ? 'w-16' : 'w-64'}
      `}>
        <div className="flex flex-col h-full">
       
          <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto">
            {navigation.map((item) => {
              const IconComponent = item.icon;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={onClose}
                  className={`
                    group flex items-center px-3 py-2 ext-sm font-medium rounded-lg transition-colors duration-200
                    ${isActive(item.href)
                      ? 'bg-primary text-white selected-item-name' 
                      : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                    }
                    ${isCollapsed ? 'justify-center' : ''}
                  `}
                  title={isCollapsed ? item.name : ''}
                >
                  <IconComponent
                    className={`
                      h-5 w-5 flex-shrink-0
                      ${isActive(item.href) ? 'text-white' : 'text-gray-400 group-hover:text-gray-500'}
                      ${isCollapsed ? '' : 'mr-3'}
                    `}
                  />
                  {!isCollapsed && item.name}
                </Link>
              );
            })}
          </nav>

      
         
        </div>
      </div>
    </>
  );
};

export default SideNav;
